import { useQuery } from "@tanstack/react-query";
import {
  storeCategory,
  storeLocations,
  weddingBanner,
  WeddingStore,
} from "api/weddingStore";

export const useWeddingStore = (filters = {}, options = {}) => {
  return useQuery({
    queryKey: ["wedding_store", filters],
    queryFn: () => WeddingStore(filters),
    ...options,
  });
};

export const useWeddingBanner = (options = {}) => {
  return useQuery({
    queryKey: ["wedding_banner"],
    queryFn: weddingBanner,
    ...options,
  });
};

export const useStoreLocations = (options = {}) => {
  return useQuery({
    queryKey: ["store_locations"],
    queryFn: storeLocations,
    ...options,
  });
};

export const useStoreCategory = (options = {}) => {
  return useQuery({
    queryKey: ["store_category"],
    queryFn: storeCategory,
    ...options,
  });
};
